import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { connect } from 'react-redux';

import { fetchDeletedStaffMembers, restoreDeletedStaffMember } from '../actions';
import DeletedStaffList from './DeletedStaffList';
import confirmModal from '../../../common/confirmModal';
import withOwnerTypeAndId from '../../../common/hoc/withOwnerTypeAndId';
import { getShopBrandId, isBrandViewActive } from '../../../auth/selectors';
import withLoadingList from '../../../common/hoc/withLoaingList';
import EmptyList from './EmptyList';

const mapStateToProps = state => ({
  brandId: getShopBrandId(state),
  isBrandView: isBrandViewActive(state),
  shop: state.auth.shop,
});

const mapDispatchToProps = { fetchDeletedStaffMembers };

export default compose(
  withOwnerTypeAndId,
  connect(mapStateToProps, mapDispatchToProps),
  withState('staffMembers', 'setStaffMembers', []),
  withHandlers({
    getDeletedStaffList: props => async () => {
      await props.fetchDeletedStaffMembers(props.ownerType, props.ownerId).then((staffMembers) => {
        props.setStaffMembers(staffMembers);
      });
    },
  }),
  withHandlers({
    onRestore: props => async (staffId) => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: 'Restore staff member',
        message: 'Are you sure you want to restore this staff member?',
      });

      if (!confirmed) {
        return false;
      }

      const restoredMember = await restoreDeletedStaffMember(props.brandId, staffId);

      await props.getDeletedStaffList();

      return restoredMember;
    },
  }),
  lifecycle({
    componentWillMount() {
      this.props.getDeletedStaffList();
    },
  }),
  withLoadingList(
    props => props.staffMembers,
    EmptyList,
  )
)(DeletedStaffList);
